import React from 'react'

const HomeChefMenuDesktop = () => {
    return (
        <div>HomeChefMenuDesktop</div>
    )
}

export default HomeChefMenuDesktop